import { AnimatePresence, motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../context/ThemeContext";
import { useNeuralAudio } from "../../lib/audio";

export interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle = ({ className }: ThemeToggleProps) => {
  const { resolvedTheme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const { play } = useNeuralAudio();

  const handleClick = () => {
    play("toggle", { variant: resolvedTheme === "dark" ? "off" : "on" });
    toggleTheme();
  };

  return (
    <motion.button
      type="button"
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      onClick={handleClick}
      onMouseEnter={() => play("hover")}
      aria-label={t("theme.toggle")}
      className={`flex size-10 items-center justify-center rounded-sm border border-border bg-surface text-primary hover:border-border-accent hover:text-accent ${
        className ?? ""
      }`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={resolvedTheme}
          initial={{ opacity: 0, rotate: -45 }}
          animate={{ opacity: 1, rotate: 0 }}
          exit={{ opacity: 0, rotate: 45 }}
        >
          {resolvedTheme === "dark" ? <Moon size={18} /> : <Sun size={18} />}
        </motion.span>
      </AnimatePresence>
    </motion.button>
  );
};
